import { useEffect } from "react";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Offerings from "@/components/Offerings";
import Highlights from "@/components/Highlights";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div
      data-testid="saath-portfolio-app"
      className="App min-h-screen bg-[#FAF7F2] font-body text-[#1C1B1A] antialiased selection:bg-[#E05A10] selection:text-white"
    >
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Offerings />
        <Highlights />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
